import React, { useEffect } from "react";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup"; // For validation
import {
    setMobileBackColor,
    setMobileCardColor,
    setMobileTextColor,
    setMobileCardBorderColor,
    setMobileButttonBackColor,
    setLocalStorageMenuItem,
    getLocalStorageMenuItem,
} from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import Toast from "../common/toast";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, Typography, IconButton } from "@mui/material";
import { ArrowBackOutlined, ChangeCircle, EditLocationAltOutlined } from "@mui/icons-material";
import { t } from "i18next";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNavBar from "../components/BottomNavBar";
import DeliveryDialog from "../components/DeliveryDialog";
import CurrentLocationDialog from "../components/map screens/CurrentLocationDialog";
import NewLocationDialog from "../components/map screens/NewLocationDialog";
import LocationFormDialog from "../components/map screens/LocationFormDialog";
import DeleteLocationDialog from "../components/DeleteLocationDialog";
import NewLocationPicker from "../components/map screens/NewLocationPicker";

const Profile = ({ tableQr, tableName }) => {
    const [profileData, setProfileData] = useState();
    const [loading, setLoading] = useState(false);
    const queryString = window.location.search;
    const urlParam = new URLSearchParams(queryString);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [phone, setPhone] = useState(getLocalStorageMenuItem("login_phone") || "");

    // Address management state
    const [mode, setMode] = useState(null);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [placeAddress, setPlaceAddress] = useState("");
    const [latLangVal, setLatLangVal] = useState(null);
    const [isEditDelivery, setIsEditDelivery] = useState(false);
    const [isProcessLoading, setIsProcessLoading] = useState(false);
    const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
    const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
    const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);

    const [defaultAddress, setDefaultAddress] = useState(null);

    const initialLocationFormData = {
        title: "",
        street: "",
        unit_number: "",
        floor_number: "",
        apartment_number: "",
        description: "",
        latitude: "",
        longitude: "",
        suburb: "",
        city: "",
        province: "",
        state: "",
        postcode: "",
        country: ""
    };

    const [locationFormData, setLocationFormData] = useState(initialLocationFormData);
    const [allTreeData, setAllTreeData] = useState(() => {
        const savedTreeData = getLocalStorageMenuItem("tree_data");
        return savedTreeData ? savedTreeData : [];
    });


    const handleOpenToast = (message, state) => {
        setToastSettings({
            open: true,
            success: state,
            message: message
        });
    };


    const handleLocationFormInputChange = (e) => {
        setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const resetLocationForm = () => {
        setLocationFormData(initialLocationFormData);
        setLatLangVal(null);
        setIsEditDelivery(false);
    };

    const navigate = useNavigate();
    const lang = getLocalStorageMenuItem("lang");

    const mobileLoginToken = getLocalStorageMenuItem('mobileLoginToken');
    const headers = {
        Authorization: `Bearer ${mobileLoginToken}`,
        'Content-Type': 'application/json',
    };

    const fetchProfileData = async () => {
        setLoading(true);
        const authToken = getLocalStorageMenuItem('mobileLoginToken');
        if (!authToken) {
            handleOpenToast(
                <div className="alignByLang">
                    {t("Authentication token is missing.")}
                </div>
                , false);
            setLoading(false);
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/get-profile`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            setProfileData(response.data.data || {});

            // Set the saved address if exists
            if (response.data.data?.address) {
                setPlaceAddress(response.data.data.address);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);

            handleOpenToast(
                <div className="alignByLang">
                    {`Error fetching profile data: ${error.response?.data?.message || error.message}`}
                </div>
                , false);
        }
    };


    // const { data: savedPlaces, refetch: refetchSavedPlaces } = useQuery(
    //     ["saved-places"],
    //     async () => {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_API}/customer/addresses`,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${mobileLoginToken}`,
    //                 },
    //             }
    //         );
    //         return response.data.data;
    //     },
    //     {
    //         enabled: !!mobileLoginToken,
    //         refetchOnWindowFocus: false,
    //         retry: 1,
    //     }
    // );



    const { data: savedPlaces, refetch: refetchSavedPlaces } = useQuery(
        ["saved-places"],
        async () => {
            const response = await axios.get(
                `${process.env.REACT_APP_API}/customer/addresses`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${mobileLoginToken}`,
                    },
                }
            );

            // Mark the default address in the list
            return response.data.data.map(address => ({
                ...address,
                isDefault: defaultAddress?.id === address.id
            }));
        },
        {
            enabled: !!mobileLoginToken,
            refetchOnWindowFocus: false,
            retry: 1,
        }
    );

    const fetchDefaultAddress = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API}/customer/addresses/default`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${mobileLoginToken}`,
                    },
                }
            );

            if (response.data.data) {
                setDefaultAddress(response.data.data);
                // Set the selected place and address if default address exists
                setSelectedPlace(response.data.data);
                const addressParts = [
                    `${t("LocationName")} ${response.data.data.title || 'NAN'}`,
                    `${t("Street")} ${response.data.data.street || 'NAN'}`,
                    `${t("Unit No")} ${response.data.data.unit_number || 'NAN'}`,
                    `${t("Floor No")} ${response.data.data.floor_number || 'NAN'}`,
                    `${t("Apartment No")} ${response.data.data.apartment_number || 'NAN'}`
                ];
                setPlaceAddress(addressParts.join(", "));
            }
        } catch (error) {
            console.error("Error fetching default address:", error);
        }
    };

    const setDefaultAddressApi = async (addressId) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/customer/addresses/${addressId}/default`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${mobileLoginToken}`,
                    },
                }
            );

            if (response.data.success) {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Default address set successfully")}
                    </div>
                    , true);


                // Update the default address in state
                setDefaultAddress(selectedPlace);
            }
        } catch (error) {
            handleOpenToast(
                <div className="alignByLang">
                    {t("Error setting default address")}
                </div>
                , false);
        }
    };


    useEffect(() => {
        fetchProfileData();
        if (mobileLoginToken) {
            fetchDefaultAddress();
        }
    }, []);

    const handleOptionSelect = (option) => {
        setMode(option);
    };

    const updateLocationFormData = (pickupMapAddress) => {
        setLocationFormData(prev => ({
            ...prev,
            unit_number: pickupMapAddress?.house_number || "",
            street: pickupMapAddress?.road || "",
            suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
            city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
            province: pickupMapAddress?.state || "",
            state: pickupMapAddress?.state || "",
            postcode: pickupMapAddress?.postcode || "",
            country: pickupMapAddress?.country || ""
        }));
    };

    const getDistanceAndDuration = async (start, end) => {
        try {
            const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
            const response = await axios.get(url);
            const data = response.data;

            const distanceInMeters = data.routes[0].distance;
            const durationInSeconds = data.routes[0].duration;

            return {
                distanceInMeters,
                durationInSeconds
            };
        } catch (error) {
            console.error('Error fetching distance and duration:', error);
            return null;
        }
    };

    // const handleSelectPlace = async (place, is_edit) => {

    //     const venue_latitude = allTreeData?.details?.venue_latitude || 0;
    //     const venue_longitude = allTreeData?.details?.venue_longitude || 0;
    //     const selectedPlace_latitude = place?.latitude || 0;
    //     const selectedPlace_longitude = place?.longitude || 0;

    //     const distanceAndDuration = await getDistanceAndDuration(
    //         { lat: venue_latitude, lng: venue_longitude },
    //         { lat: selectedPlace_latitude, lng: selectedPlace_longitude }
    //     );


    //     if (distanceAndDuration) {
    //         const { distanceInMeters, durationInSeconds } = distanceAndDuration;
    //         const distanceInKm = (distanceInMeters / 1000).toFixed(2);
    //         if (distanceInKm > 20) {
    //             handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
    //             return;
    //         }

    //     }

    //     setLocationFormData(place || {});
    //     setIsEditDelivery(is_edit);




    //     const addressParts = [
    //         `${t("LocationName")} ${place.title || 'NAN'}`,
    //         `${t("Street")} ${place.street || 'NAN'}`,
    //         `${t("Unit No")} ${place.unit_number || 'NAN'}`,
    //         `${t("Floor No")} ${place.floor_number || 'NAN'}`,
    //         `${t("Apartment No")} ${place.apartment_number || 'NAN'}`
    //     ];

    //     setPlaceAddress(addressParts.join(", "));
    //     setSelectedPlace(place);

    //     if (!is_edit) {
    //         resetLocationForm();
    //         setDeliveryDialogOpen(false);
    //     }
    // };


    const handleSelectPlace = async (place, is_edit) => {
        const venue_latitude = allTreeData?.details?.venue_latitude || 0;
        const venue_longitude = allTreeData?.details?.venue_longitude || 0;
        const selectedPlace_latitude = place?.latitude || 0;
        const selectedPlace_longitude = place?.longitude || 0;

        const distanceAndDuration = await getDistanceAndDuration(
            { lat: venue_latitude, lng: venue_longitude },
            { lat: selectedPlace_latitude, lng: selectedPlace_longitude }
        );

        if (distanceAndDuration) {
            const { distanceInMeters } = distanceAndDuration;
            const distanceInKm = (distanceInMeters / 1000).toFixed(2);
            if (distanceInKm > 20) {
                handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
                return;
            }
        }

        setLocationFormData(place || {});
        setIsEditDelivery(is_edit);

        const addressParts = [
            `${t("LocationName")} ${place.title || 'NAN'}`,
            `${t("Street")} ${place.street || 'NAN'}`,
            `${t("Unit No")} ${place.unit_number || 'NAN'}`,
            `${t("Floor No")} ${place.floor_number || 'NAN'}`,
            `${t("Apartment No")} ${place.apartment_number || 'NAN'}`
        ];

        setPlaceAddress(addressParts.join(", "));
        setSelectedPlace(place);

        // Set this address as default when selected
        if (!is_edit) {
            await setDefaultAddressApi(place.id);
        }

        if (!is_edit) {
            resetLocationForm();
            setDeliveryDialogOpen(false);
        }
    };


    const handleSaveLocation = async () => {
        setIsProcessLoading(true);
        const newPlace = {
            ...locationFormData,
            latitude: latLangVal?.lat + "",
            longitude: latLangVal?.lng + "",
        };

        const token = getLocalStorageMenuItem("mobileLoginToken");

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/customer/addresses`,
                newPlace,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setMode(null);

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Location has been added successfully")}
                    </div>
                    , true);

                handleCloseFormDialog();
                resetLocationForm();
                refetchSavedPlaces();
            }
        } catch (error) {
            handleOpenToast(
                <div className="alignByLang">
                    {"Error saving location:" + error}
                </div>
                , false);
        } finally {
            setIsProcessLoading(false);
        }
    };

    const handleUpdateLocation = async () => {
        setIsProcessLoading(true);
        const token = getLocalStorageMenuItem("mobileLoginToken");
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
                locationFormData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setMode(null);
                handleOpenToast(
                    <div className="alignByLang">
                        {t("Location has been updated successfully")}
                    </div>
                    , true);
                handleCloseFormDialog();
                resetLocationForm();
                refetchSavedPlaces();
            }
        } catch (error) {
            handleOpenToast(
                <div className="alignByLang">
                    {t("Error updating location:" + error)}
                </div>
                , false);
            console.error("Error updating location:", error);
        } finally {
            setIsProcessLoading(false);
        }
    };

    const handleDeleteLocation = async () => {
        setIsProcessLoading(true);
        const token = getLocalStorageMenuItem("mobileLoginToken");
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setMode(null);
                handleOpenToast(
                    <div className="alignByLang">
                        {t("Location has been deleted successfully")}
                    </div>
                    , true);
                resetLocationForm();
                setDeleteLocationDialogOpen(false);
                refetchSavedPlaces();
            }
        } catch (error) {
            handleOpenToast(
                <div className="alignByLang">
                    {t("Error deleting location:") + " " + error.message}
                </div>
                , false);
            console.error("Error deleting location:", error);
        } finally {
            setIsProcessLoading(false);
        }
    };

    const handleCloseFormDialog = () => {
        setOpenLocationFormDialog(false);
        resetLocationForm();
    };

    const handleOpenDeleteLocationDialog = (place) => {
        setDeleteLocationDialogOpen(true);
        setSelectedPlace(place);
    };

    const [toastSettings, setToastSettings] = useState({
        open: false,
        message: "",
        success: false,
    });

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '20px',
        },
        profileImage: {
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            marginBottom: '20px',
        },
        form: {
            width: '100%',
            maxWidth: '400px',
            margin: '0 auto',
        },
        phoneInput: {
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '10px',
            fontSize: '16px',
        },
        errorMessage: {
            color: 'red',
            marginBottom: '10px',
        },
        button: {
            width: '100%',
        },
        verificationCodeInput: {
            marginBottom: '20px',
        },
    };

    const handleBack = () => {
        if (urlParam.get("section")) {
            navigate(
                `/${tableName}/${tableQr}/sections?section=${urlParam.get(
                    "section"
                )}&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
            );
        } else {
            navigate(
                `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get(
                    "t"
                )}&lang=${getLocalStorageMenuItem("lang")}`
            );
        }
    };

    const handleBackHome = () => {
        navigate(
            `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get(
                "t"
            )}&lang=${getLocalStorageMenuItem("lang")}`
        );
    };

    const onImageError = (e) => {
        e.target.src = coverSample;
    };

    const { data, isLoading, isFetching, isError, error } = useQuery(
        "public-details",
        async () => {
            try {
                const timeZone = getLocalStorageMenuItem("timezone")
                    ? getLocalStorageMenuItem("timezone")
                    : "";

                const promise = await axios.get(
                    `${process.env.REACT_APP_API}/menus/${tableQr}/public-details`,
                    { headers: { localization: getLocalStorageMenuItem("lang"), timeZone } }
                );
                if (promise.status === 200) {
                    if (!getLocalStorageMenuItem("showOption")) {
                        setLocalStorageMenuItem(
                            "showOption",
                            promise.data.data.mobile_settings?.showOption
                        );
                    }
                    if (promise.data.data.mobile_settings?.theme === "costomize") {
                        setLocalStorageMenuItem(
                            "theme",
                            promise.data.data.mobile_settings?.theme
                        );
                        setLocalStorageMenuItem(
                            "textColor",
                            promise.data?.data.mobile_settings.colorProps.text
                        );
                        setLocalStorageMenuItem(
                            "backColor",
                            promise.data?.data.mobile_settings.colorProps.back
                        );
                        setLocalStorageMenuItem(
                            "cardColor",
                            promise.data?.data.mobile_settings.colorProps.card
                        );
                        setLocalStorageMenuItem(
                            "highlights",
                            promise.data?.data.mobile_settings.colorProps.highlights
                        );
                    } else {
                        if (
                            getLocalStorageMenuItem("theme") !== "dark" &&
                            getLocalStorageMenuItem("theme") !== "light"
                        ) {
                            setLocalStorageMenuItem(
                                "theme",
                                promise.data.data.mobile_settings?.theme
                            );
                        }
                    }
                }
                return promise;
            } catch (error) { }
        }
    );

    const handleCloseToast = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setToastSettings({ open: false, message: "", success: false });
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(t("Name Is Required")),
        email: Yup.string()
            .email(t("Invalid email address"))
            .required(t("Email Is Required")),
    });

    const goHome = () => {
        navigate(`/${tableName}/${tableQr}/menus?lang=${getLocalStorageMenuItem("lang")}`);
    }

    const handleSendCode = async () => {
        if (mobileLoginToken) {
            try {
                const sendOtpRes = await axios.post(`${process.env.REACT_APP_API}/update-phone-number-send-otp`, {
                    'phone': phone
                }, { headers });
                if (sendOtpRes?.data?.success) {

                    handleOpenToast(
                        <div className="alignByLang">
                            {t("verification code sent successfully")}
                        </div>
                        , true);
                    setVerificationCode("");
                    setDialogOpen(true);
                } else {

                    handleOpenToast(
                        <div className="alignByLang">
                            {t("Error while sending the verification code.")}
                        </div>
                        , false);
                }
            } catch (error) {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while sending the verification code.") + " " + error.message}
                    </div>
                    , false);
            }
        } else {

            handleOpenToast(
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <span>{t("Please login to continue")}</span>
                    </div>
                    <div>
                        <button
                            onClick={goHome}
                            style={{
                                color: '#fff',
                                backgroundColor: '#ff6347',
                                border: 'none',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                textDecoration: 'none'
                            }}
                        >
                            {t("login")}
                        </button>
                    </div>
                </div>
                , false);
        }
    };

    const handleVerifyCode = async () => {
        setLoading(true);

        if (mobileLoginToken) {
            if (verificationCode && verificationCode.length > 0) {
                try {
                    const checkOtpRes = await axios.post(`${process.env.REACT_APP_API}/update-phone-number-cehck-otp`, {
                        'phone': phone,
                        'otp': verificationCode
                    }, { headers });
                    if (checkOtpRes?.data?.success) {
                        setLoading(false);
                        setLocalStorageMenuItem("login_phone", phone)

                        handleOpenToast(
                            <div className="alignByLang">
                                {t("Phone updated successfully")}
                            </div>
                            , true);
                        setLocalStorageMenuItem("login_phone", phone);
                        setLocalStorageMenuItem("mobileLoginToken", checkOtpRes?.data?.data?.token || "")
                        setDialogOpen(false);
                        handleLogout();
                    } else {
                        setLoading(false);

                        handleOpenToast(
                            <div className="alignByLang">
                                {t("Error while verifing the code!")}
                            </div>
                            , false);
                    }
                } catch (error) {
                    setLoading(false);

                    handleOpenToast(
                        <div className="alignByLang">
                            {t("Error while verifing the code!") + " " + error}
                        </div>
                        , false);
                }
            } else {
                setLoading(false);

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Please enter the verification code!")}
                    </div>
                    , false);
            }
        } else {
            setLoading(false);


            handleOpenToast(
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <span>{t("Please login to continue")}</span>
                    </div>
                    <div>
                        <button
                            onClick={goHome}
                            style={{
                                color: '#fff',
                                backgroundColor: '#ff6347',
                                border: 'none',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                textDecoration: 'none'
                            }}
                        >
                            {t("login")}
                        </button>
                    </div>
                </div>
                , false);
        }
    };

    const handleLogout = async () => {
        await setLocalStorageMenuItem("mobileLoginToken", "");
        navigate(`/${tableName}/${tableQr}/menus?lang=${lang}`);
    };

    const updateProfileData = async (values) => {
        try {
            const profileParams = {
                name: values?.name || "",
                email: values?.email || "",
                address: placeAddress || values?.address || "",
                gender: values?.gender || "",
                birth_date: values?.birth_date || ""
            }
            const checkUpdateProfile = await axios.post(`${process.env.REACT_APP_API}/update-profile`, profileParams, { headers });
            if (checkUpdateProfile?.data?.success) {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Profile updated successfully")}
                    </div>
                    , true);
            } else {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while updating the profile!")}
                    </div>
                    , false);
            }
        } catch (error) {


            handleOpenToast(
                <div className="alignByLang">
                    {t("Error while updating the profile!") + " " + error}
                </div>
                , false)
        }
    }

    const handleOpenDialog = () => {
        if (phone) {
            handleSendCode();
        } else {

            handleOpenToast(
                <div className="alignByLang">
                    {t("Phone number is required")}
                </div>
                , false)
        }
    }

    if (isLoading || loading) {
        return <Loading />;
    }

    return (
        <div
            className={`min-vh-100`}
            style={{ backgroundColor: setMobileBackColor() }}
        >
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Container fluid>
                <div style={{ marginBottom: 70 }} className="row">
                    <div className="col-lg-8 d-none d-lg-block">
                        <div className="vh-100 mt-5 text-center d-flex-justify-content-center align-items-center">
                            <div style={{ marginTop: "20%" }}>
                                <img
                                    src={data.data.data?.logo || no_image}
                                    className="me-4"
                                    style={{ width: "250px", height: "250px" }}
                                    onError={onImageError}
                                />
                                <h1
                                    className="mt-4 head-font"
                                    style={{ color: setMobileTextColor() }}
                                >
                                    {data.data.data?.venu_name}
                                </h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 ms-auto p-0">
                        <div className="mobile-side-screen">
                            <div className="slider-mobile">
                                <img
                                    src={data?.data.data.cover || coverSample}
                                    onError={onImageError}
                                    className="slider-mobile-image"
                                />
                                <Navbar
                                    className={`d-flex justify-content-between align-items-center mobile-top-nav`}
                                    style={{ backgroundColor: setMobileBackColor() }}
                                >
                                    <Button
                                        variant="text"
                                        className={`ms-2 dark-color cursor`}
                                        style={{ color: setMobileTextColor() }}
                                        onClick={() => handleBack()}
                                    >
                                        <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                                    </Button>

                                    <Navbar.Brand className="text-center">
                                        <img
                                            src={data?.data.data.logo || no_image}
                                            className="me-4 slider-mobile-logo cursor"
                                            onError={onImageError}
                                            onClick={handleBackHome}
                                        />
                                    </Navbar.Brand>
                                </Navbar>
                            </div>

                            <div className="sections">
                                <div
                                    className="sections-content"
                                    style={{ marginTop: "64px", marginBottom: "24px" }}
                                >
                                    <Formik
                                        initialValues={{
                                            name: profileData?.name || "",
                                            address: profileData?.address || "",
                                            phone: profileData?.phone || "",
                                            email: profileData?.email || "",
                                            gender: profileData?.gender || "",
                                            birth_date: profileData?.birth_date || ""
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={(values) => {
                                            updateProfileData(values);
                                        }}
                                    >
                                        {({ values, setFieldValue }) => (
                                            <Form>
                                                <div className="d-flex flex-column align-items-center">
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="phone"
                                                            className="form-label d-block"
                                                        >
                                                            {t("Phone Number")}
                                                        </label>

                                                        <div style={{ display: 'flex', justifyContent: "space-between", flexDirection: "row" }}>
                                                            <Field name="phone">
                                                                {({ field }) => (
                                                                    <PhoneInput
                                                                        className="head-font"
                                                                        {...field}
                                                                        placeholder={t("Enter phone number")}
                                                                        value={getLocalStorageMenuItem("login_phone") || values.phone}
                                                                        onChange={(value) => {
                                                                            setFieldValue("phone", value)
                                                                            setPhone(value)
                                                                        }}
                                                                        defaultCountry="SA"
                                                                        style={styles.phoneInput}
                                                                    />
                                                                )}
                                                            </Field>
                                                            <IconButton
                                                                className="head-font"
                                                                style={{ width: "20%" }}
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => handleOpenDialog()}
                                                            >
                                                                <ChangeCircle />
                                                            </IconButton>
                                                        </div>
                                                        <ErrorMessage name="phone" component="div" className="text-danger" />
                                                    </div>

                                                    {/* Address Section */}
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="address"
                                                            className="form-label d-block"
                                                        >
                                                            {t("Address")}
                                                        </label>

                                                        <Box
                                                            component="div"
                                                            onClick={() => setDeliveryDialogOpen(true)}
                                                            sx={{
                                                                mt: 1,
                                                                mb: 2,
                                                                px: 2,
                                                                py: 1,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                backgroundColor: setMobileButttonBackColor() + '10',
                                                                borderRadius: "20px",
                                                                cursor: "pointer",
                                                                width: "100%",
                                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                                transition: "all 0.2s ease",
                                                                '&:hover': {
                                                                    backgroundColor: setMobileButttonBackColor() + '20',
                                                                }
                                                            }}
                                                        >
                                                            <EditLocationAltOutlined
                                                                sx={{
                                                                    mr: 1,
                                                                    color: setMobileButttonBackColor(),
                                                                }}
                                                                fontSize="small"
                                                            />
                                                            <Typography
                                                                variant="body2"
                                                                className="sub-font"
                                                                sx={{
                                                                    color: setMobileTextColor(),
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                {selectedPlace?.title || placeAddress || profileData?.address || t("Select Address")}
                                                            </Typography>
                                                        </Box>

                                                        <Field
                                                            name="address"
                                                            type="text"
                                                            value={placeAddress || profileData?.address || ""}
                                                            className="form-control head-font"
                                                            placeholder={t("Enter Your Address")}
                                                            onChange={(e) => {
                                                                setFieldValue("address", e.target.value);
                                                                setPlaceAddress(e.target.value);
                                                            }}
                                                            hidden
                                                        />
                                                    </div>

                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="name"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Name")}
                                                        </label>

                                                        <Field
                                                            name="name"
                                                            type="text"
                                                            value={values.name}
                                                            className="form-control head-font"
                                                            placeholder={t("Enter Your Name")}
                                                            onChange={(e) => setFieldValue("name", e.target.value)}
                                                            style={{

                                                                backgroundColor: setMobileButttonBackColor() + '10',
                                                                color: setMobileTextColor(),
                                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                                transition: "all 0.2s ease",
                                                                '&:hover': {
                                                                    backgroundColor: setMobileButttonBackColor() + '20',
                                                                }
                                                            }}

                                                        />


                                                        <ErrorMessage
                                                            name="name"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>

                                                    {/* Gender */}
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="gender"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Gender")}
                                                        </label>
                                                        <Field
                                                            as="select"
                                                            name="gender"
                                                            className="form-control head-font"
                                                            value={values.gender}
                                                            onChange={(e) => setFieldValue("gender", e.target.value)}

                                                            style={{

                                                                backgroundColor: setMobileButttonBackColor() + '10',
                                                                color: setMobileTextColor(),
                                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                                transition: "all 0.2s ease",
                                                                '&:hover': {
                                                                    backgroundColor: setMobileButttonBackColor() + '20',
                                                                }
                                                            }}
                                                        >
                                                            <option style={{ backgroundColor: setMobileBackColor() }} value="">{t("Select Gender")}</option>
                                                            <option style={{ backgroundColor: setMobileBackColor() }} value="male">{t("Male")}</option>
                                                            <option style={{ backgroundColor: setMobileBackColor() }} value="female">{t("Female")}</option>


                                                        </Field>
                                                        <ErrorMessage
                                                            name="gender"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>

                                                    {/* Birth Date */}
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="birth_date"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Birth Date")}
                                                        </label>
                                                        <Field
                                                            name="birth_date"
                                                            type="date"
                                                            className="form-control head-font"
                                                            value={values.birth_date}
                                                            onChange={(e) => setFieldValue("birth_date", e.target.value)}

                                                            style={{

                                                                backgroundColor: setMobileButttonBackColor() + '10',
                                                                color: setMobileTextColor(),
                                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                                transition: "all 0.2s ease",
                                                                '&:hover': {
                                                                    backgroundColor: setMobileButttonBackColor() + '20',
                                                                }
                                                            }}
                                                        />
                                                        <ErrorMessage
                                                            name="birth_date"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>

                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="email"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("E-mail")}
                                                        </label>
                                                        <Field
                                                            name="email"
                                                            type="email"
                                                            value={values.email}
                                                            className="form-control head-font"
                                                            placeholder={t("Enter Your Email")}
                                                            onChange={(e) => setFieldValue("email", e.target.value)}
                                                            style={{

                                                                backgroundColor: setMobileButttonBackColor() + '10',
                                                                color: setMobileTextColor(),
                                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                                transition: "all 0.2s ease",
                                                                '&:hover': {
                                                                    backgroundColor: setMobileButttonBackColor() + '20',
                                                                }
                                                            }}
                                                        />
                                                        <ErrorMessage
                                                            name="email"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        className="mt-3 head-font"
                                                    >
                                                        {t("save")}
                                                    </Button>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>

                        {/* Verification Code Dialog */}
                        <Dialog className="alignByLang" open={dialogOpen} onClose={() => setDialogOpen(false)}>
                            <DialogTitle className="head-font">{t("Enter Verification Code")}</DialogTitle>
                            <DialogContent className="head-font alignByLang">
                                <TextField
                                    className="head-font alignByLang"
                                    required
                                    label={t("Verification Code")}
                                    variant="outlined"
                                    value={verificationCode}
                                    onChange={(e) => setVerificationCode(e.target.value)}
                                    fullWidth
                                    style={styles.verificationCodeInput}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button className="head-font" onClick={handleVerifyCode} color="primary">
                                    {t("Verify")}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>

                    <Toast
                        open={toastSettings.open}
                        message={toastSettings.message}
                        resetToast={handleCloseToast}
                        success={toastSettings.success}
                    />
                </div>
            </Container>

            {/* Address Management Dialogs */}
            <DeliveryDialog
                open={deliveryDialogOpen}
                savedPlaces={savedPlaces}
                isLoadingSavedPlaces={isLoading}
                openLocationFormDailog={() => setOpenLocationFormDialog(true)}
                onClose={() => setDeliveryDialogOpen(false)}
                onSelect={handleOptionSelect}
                onSelectPlace={handleSelectPlace}
                openDeleteLocationDialog={handleOpenDeleteLocationDialog}
            />

            <CurrentLocationDialog
                open={mode === "current"}
                onClose={() => setMode(null)}
                setLatLangVal={setLatLangVal}
                updateLocationFormData={updateLocationFormData}
                setMobileBackColor={setMobileBackColor}
                setMobileTextColor={setMobileTextColor}
                setMobileCardBorderColor={setMobileCardBorderColor}
            />

            <NewLocationDialog
                open={mode === "new"}
                onClose={() => setMode(null)}
                openLocationFormDailog={() => setOpenLocationFormDialog(true)}
                closeLocationFormDailog={() => handleCloseFormDialog()}
                setLatLangVal={setLatLangVal}
                closeMapModal={() => setMode(null)}
                updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
                setMobileBackColor={setMobileBackColor}
                setMobileTextColor={setMobileTextColor}
                setMobileCardBorderColor={setMobileCardBorderColor}
            />


            <LocationFormDialog
                open={openLocationFormDialog}
                onClose={handleCloseFormDialog}
                isEditDelivery={isEditDelivery}
                isProcessLoading={isProcessLoading}
                locationFormData={locationFormData}
                handleLocationFormInputChange={handleLocationFormInputChange}
                handleSaveLocation={handleSaveLocation}
                handleUpdateLocation={handleUpdateLocation}
                setMobileBackColor={setMobileBackColor}
                setMobileTextColor={setMobileTextColor}
                setMobileCardBorderColor={setMobileCardBorderColor}
                setMobileCardColor={setMobileCardColor}
                setMobileButttonBackColor={setMobileButttonBackColor}
            />

            <DeleteLocationDialog
                onDeleteDeleteLocationDialog={handleDeleteLocation}
                deleteLocationDialogOpen={deleteLocationDialogOpen}
                onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
            />

            <BottomNavBar qr={tableQr} qrName={tableName} />
        </div>
    );
};

export default Profile;